import { useMemo } from "react";
import { useFiltersConfig } from "./useFiltersConfig";

const getKeys = ({ id, accessor, accessorKey, name }: any) =>
    [id, accessorKey, name, typeof accessor === "string" ? accessor : undefined]
        .filter((key) => key !== undefined && key !== null)
        .map(String);

export const useConfigFilterColumns = (feature: string, filters: any[]) => {
    const configFilters = useFiltersConfig(feature);

    const hidden = useMemo(() => {
        if (!Array.isArray(configFilters)) {
            return [];
        }
        return configFilters
            .filter(({ hide }: any) => hide)
            .map(({ accessor }: any) => accessor);
    }, [configFilters]);

    return useMemo(() => {
        return (filters || []).filter((filter: any) => {
            return !getKeys(filter).some((key) => hidden.includes(key));
        });
    }, [filters, hidden]);
};
